// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_eh-j";
export var fulfillmentFormRail = "_eh-i";
export var headerTitleRow = "_eh-l";
export var orderDetailsWrapper = "_eh-g";
export var orderLinkTrigger = "_eh-2";
export var paymentInformationGrid = "_eh-q";
export var paymentSummaryColumn = "_eh-r";
export var phoneShipmentPickerButton = "_eh-e";
export var phoneShipmentPickerButtonContent = "_eh-f";
export var phoneShipmentPickerButtonWrapper = "_eh-d";
export var phoneShipmentPickerTrigger = "_eh-c";
export var shipmentContainer = "_eh-k";
export var shipmentDetailsMainPane = "_eh-h";
export var shipmentNavigationCard = "_eh-a";
export var shipmentNavigationEdgeTrigger = "_eh-6";
export var shipmentNavigationRail = "_eh-3";
export var shipmentNavigationRailEnter = "_eh-5";
export var shipmentNavigationRailHeader = "_eh-9";
export var shipmentNavigationRailOverlay = "_eh-4";
export var shipmentNavigationScrim = "_eh-7";
export var shipmentSummaryFact = "_eh-n";
export var shipmentSummaryGrid = "_eh-m";
export var shipmentSummaryMetadataRow = "_eh-o";
export var shipmentSummaryTags = "_eh-p";
export var shipmentWorkspace = "_eh-0";
export var shipmentWorkspaceBodyTablet = "_eh-8";
export var shipmentWorkspaceContent = "_eh-b";
export var shipmentWorkspaceHeader = "_eh-1";